import React from "react";
import { Admin } from "react-admin";
import authProvider from "../config/firebaseAuthProvider";
import LoginPage from "./LoginPage";

const RedirectToLoginPage = () => (
	<Admin authProvider={authProvider} loginPage={LoginPage} title="No auth" requireAuth>
		{[]}
	</Admin>
);

export default RedirectToLoginPage;
